import { Component, Input, OnInit } from '@angular/core';
import { EchartsOption } from '@src/app/shared/directives/echarts.directive';
import { LIFO_CHART_COLORS } from '@src/app/shared/types/general.type';

@Component({
    selector: 'app-general-line-series-chart',
    templateUrl: './general-line-series-chart.component.html',
    styleUrls: ['./general-line-series-chart.component.less'],
})
export class GeneralLineSeriesChartComponent {
    @Input() theme: 'dark' | 'light' = 'dark';
    @Input() sectionTitle: string;
    @Input() sectionDescription: string;
    @Input() optionToBeUpdate: EchartsOption;

    initialOption: EchartsOption = {
        title: {
            show: false,
        },
        color: LIFO_CHART_COLORS,
        backgroundColor: 'transparent',
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'cross',
                label: {
                    backgroundColor: '#6a7985',
                },
            },
            backgroundColor: 'rgba(0,0,0,0.8)',
            borderColor: 'transparent',
            formatter: params => {
                let html = `<div style="color:#fff">${params[0].name}<br/>`;

                for (let i = 0; i < params.length; i++) {
                    html += `<div style="white-space:nowrap;">
                        <span>${params[i].marker}</span>
                        <span>${params[i].seriesName}</span>
                        <span style="float:right;padding-left:10px;">
                            ${params[i].value}
                        </span>
                    </div>`;
                }
                // eslint-disable-next-line prefer-template
                return html + '</div>';
            },
        },
        legend: {
            type: 'scroll',
            left: 0,
            top: 0,
            data: null,
            tooltip: {
                show: true,
                textStyle: {
                    color: '#fff',
                },
            },
        },

        grid: {
            top: '50',
            left: '10',
            right: '10',
            bottom: '10',
            containLabel: true,
        },
        xAxis: {
            type: 'time',
            boundaryGap: false,
            data: null,
            axisLine: {
                show: false,
            },
            axisTick: {
                show: false,
            },
        },
        yAxis: [
            {
                type: 'value',
                axisPointer: {
                    label: {
                        precision: 0,
                    },
                },
                splitLine: {
                    lineStyle: {
                        color: '#4C4C4F',
                        type: 'dashed',
                    },
                },
            },
            {
                type: 'value',
                axisPointer: {
                    label: {
                        precision: 0,
                    },
                },
                splitLine: {
                    lineStyle: {
                        color: '#4C4C4F',
                        type: 'dashed',
                    },
                },
            },
        ],
    };

    constructor() {}
}
